import { useTranslation } from "react-i18next";
import { Button, Col, DatePicker, Form, FormInstance, Row, Typography } from 'antd';
import React, { useEffect } from 'react';
import FormItemDropdown from '../../../../form-dropdown/FormItemDropdown';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { FilterData } from "./filter";

type FilterMyQuestionBankTypes = {
  form: FormInstance,
  showFilter: boolean,
  onFinish: () => void;
  filterData: FilterData
  setFilterData?: (dateString: string[], planCreationDate: string) => void
  clearFilter: () => void;
  dataOptions?: any;
  typeQuestion?: boolean;
  onFinishFilter?: (values: FilterData) => void;
}
const FilterMyQuestionBank = ({
  form, 
  showFilter,
  filterData,
  setFilterData,
  dataOptions,
  clearFilter,
  typeQuestion,
  onFinishFilter
}: FilterMyQuestionBankTypes) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;


  const handleFinish = (values: any) => {
    let convertedDates: string[] = [];
    if (values.updatedDate && values.updatedDate.length === 2) {
      const [startDayjs, endDayjs] = values.updatedDate;
      convertedDates = [
        startDayjs.format("YYYY-MM-DD"),
        endDayjs.format("YYYY-MM-DD"),
      ];
    }
    onFinishFilter && onFinishFilter({
      ...values,
      updatedDate: convertedDates,
    });
  };
  return (
    <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
      <Form form={form} name="filterForm" onFinish={handleFinish}>
        <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
          <Col
            xl={{ span: 4 }}
            md={{ span: 5 }}
            sm={{ span: 5 }}
            xs={{ span: 24 }}
          >
            <Typography.Title level={5}>{t("Câu hỏi", "Câu hỏi")}</Typography.Title>
            <Form.Item name="questionId">
              <FormItemDropdown
                placeholder={t("Chọn loại câu hỏi", "Chọn loại câu hỏi")}
                options={dataOptions.dataTopic}
                value={filterData.questionId}
                onChange={(option) => setFilterData && setFilterData(option, "questionId")}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col
            xl={{ span: 4 }}
            md={{ span: 5 }}
            sm={{ span: 5 }}
            xs={{ span: 24 }}
          >
            <Typography.Title level={5}>{t("Độ khó", "Độ khó")}</Typography.Title>
            <Form.Item name="difficulty">
              <FormItemDropdown
                placeholder={t("Chọn độ khó", "Chọn độ khó")}
                options={dataOptions.dataDifficulty}
                value={filterData.difficulty}
                onChange={(option) => setFilterData && setFilterData(option, "difficulty")}
                allowClear
              />
            </Form.Item>
          </Col>
          {
            !typeQuestion ?
              <>
                <Col
                  xl={{ span: 4 }}
                  md={{ span: 5 }}
                  sm={{ span: 5 }}
                  xs={{ span: 24 }}
                >
                  <Typography.Title level={5}>{t("Quyền truy cập", "Quyền truy cập")}</Typography.Title>
                  <Form.Item name="permission">
                    <FormItemDropdown
                      modeDropdown="multiple"
                      placeholder={t("Chọn quyền truy cập", "Chọn quyền truy cập")}
                      options={dataOptions.dataPermission}
                      value={filterData.permission}
                      onChange={(option) => setFilterData && setFilterData(option, "permission")}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col
                  xl={{ span: 4 }}
                  md={{ span: 5 }}
                  sm={{ span: 5 }}
                  xs={{ span: 24 }}
                >
                  <Typography.Title level={5}>{t("Tình trạng", "Tình trạng")}</Typography.Title>
                  <Form.Item name="status">
                    <FormItemDropdown
                      placeholder={t("Chọn tình trạng", "Chọn tình trạng")}
                      modeDropdown="multiple"
                      options={dataOptions.dataStatus}
                      value={filterData.status}
                      onChange={(option) => setFilterData && setFilterData(option, "status")}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </> :
              <>
                <Col
                  xl={{ span: 4 }}
                  md={{ span: 5 }}
                  sm={{ span: 5 }}
                  xs={{ span: 24 }}
                >
                  <Typography.Title level={5}>{t("Chọn phân cấp", "Chọn phân cấp")}</Typography.Title>
                  <Form.Item name="typeProduction">
                    <FormItemDropdown
                      modeDropdown="multiple"
                      placeholder={t("Chọn phân cấp", "Chọn phân cấp")}
                      options={dataOptions.dataTypeProduction}
                      onChange={(option) => setFilterData && setFilterData(option, "typeProduction")}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xl={{ span: 4 }}
                  md={{ span: 5 }}
                  sm={{ span: 5 }}
                  xs={{ span: 24 }}
                >
                  <Typography.Title level={5}>{t("Chọn Đơn vị xuất bản", "Chọn Đơn vị xuất bản")}</Typography.Title>
                  <Form.Item name="unit">
                    <FormItemDropdown
                      modeDropdown="multiple"
                      placeholder={t("Chọn đơn vị xuất bản", "Chọn đơn vị xuất bản")}
                      options={dataOptions.dataUnit}
                      onChange={(option) => setFilterData && setFilterData(option, "unit")}
                    />
                  </Form.Item>
                </Col>
              </>
          }
          <Col
            xl={{ span: 4 }}
            md={{ span: 5 }}
            sm={{ span: 5 }}
            xs={{ span: 24 }}
          >
            <Typography.Title level={5}>{t("Ngày cập nhật", "Ngày cập nhật")}</Typography.Title>
            <Form.Item name="updatedDate">
              <RangePicker
                placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}
                format="DD-MM-YYYY"

              />
            </Form.Item>
          </Col>

          <Col
            xl={{ span: 3 }}
            md={{ span: 9 }}
            sm={{ span: 9 }}
            xs={{ span: 24 }}
            className="flex align-end"
          >
            <div className="group-btn--filter">
              <Button
                className="btn btn-primary filter-btn"
                htmlType="submit"
                onClick={() => form.submit()}
              >
                <FilterOutlined />
                <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-outlined clear-filter-btn"
                onClick={clearFilter}
              >
                <DeleteOutlined />
                <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default FilterMyQuestionBank;